  export const HandleScroll = (format:any,
    selectedDirIndex:any,
    totalPages:any,
    userScrolling:any,
    iframeRef:any,
    currentPage:any,
    setCurrentPage:any,
    imageContainerRef:any
  ) => {
    if (format === 'pdf' || selectedDirIndex < 0 || totalPages <= 1) return;
    userScrolling.current = true;
    if (format === 'text' || format === 'pdf_pages') {
      const iframe = iframeRef.current;
      if (!iframe || !iframe.contentWindow) return;
      const scrollTop = iframe.contentWindow.scrollY || 0;
      const scrollHeight = iframe.contentWindow.document.body.scrollHeight || 0;
      const pageHeight = scrollHeight / totalPages;
      const newPage = Math.max(1, Math.min(totalPages, Math.floor(scrollTop / pageHeight) + 1));
      if (newPage !== currentPage) setCurrentPage(newPage);
    } else if (format === 'images') {
      const container = imageContainerRef.current;
      if (!container) return;
      const scrollTop = container.scrollTop;
      const scrollHeight = container.scrollHeight;
      const pageHeight = scrollHeight / totalPages;
      const newPage = Math.max(1, Math.min(totalPages, Math.floor(scrollTop / pageHeight) + 1));
      if (newPage !== currentPage) setCurrentPage(newPage);
    }
    setTimeout(() => { userScrolling.current = false; }, 100);
  };
